import Alert from './alert';

export default {
	/**
	 * Copy the given value to the clipboard.
	 *
	 * @param {string} _type - type of thing being copied (e.g. email). Used for alert
	 * @param {string} value - any string
	 */
	copy(_type: string, value: string) {
		try {
			navigator.clipboard.writeText(value).then(() => {});
		}
		catch (err: any) {
			Alert.addSimpleError(`Failed to add '${value}' to clipboard`, err.message);
		}
	}
}
